import axios from "axios";
import { api } from "../config";

// default
axios.defaults.baseURL = api.API_URL;
// content type
axios.defaults.headers.post["Content-Type"] = "application/json";

// content type
const token = JSON.parse(sessionStorage.getItem("authUser")) ? JSON.parse(sessionStorage.getItem("authUser")).token : null;
if(token)
axios.defaults.headers.common["Authorization"] = "Bearer " + token;

// intercepting to capture errors
axios.interceptors.response.use(
  function (response) {
    return response.data ? response.data : response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    let message;

    const status = error.response?.status;
    const errCode = error.response?.data?.error;

    // Session expiry: clear the dead token, kick the user to login.
    // Without this, axios.defaults.headers still carries the expired Bearer
    // and every subsequent poll (notifications, dashboards, feature flags)
    // triggers a fresh 401 — flooding the backend logs.
    if (status === 401 && (errCode === 'token_expired' || errCode === 'token_invalid')) {
      try {
        sessionStorage.removeItem('authUser');
        sessionStorage.removeItem('featureFlagsLoaded');
        localStorage.removeItem('rememberAuthUser');
      } catch (_) { /* ignore */ }
      delete axios.defaults.headers.common['Authorization'];
      // Don't redirect on the auth endpoints themselves, and don't loop if
      // we're already on the login page.
      const path = typeof window !== 'undefined' ? window.location.pathname : '';
      const isAuthCall = (error.config?.url || '').includes('/auth/');
      if (!isAuthCall && !path.startsWith('/login') && !path.startsWith('/register')) {
        try { window.location.assign('/login?reason=expired'); } catch (_) { /* ignore */ }
      }
      return Promise.reject('Session expired. Please sign in again.');
    }

    console.error("API Error Response:", error.response);

    // Try to extract error message from backend response
    if (error.response?.data) {
      // If backend returns an error message
      if (typeof error.response.data === 'string') {
        message = error.response.data;
      } else if (error.response.data.message) {
        message = error.response.data.message;
      } else if (error.response.data.error) {
        message = error.response.data.error;
      } else {
        message = JSON.stringify(error.response.data);
      }
    } else {
      // Handle different HTTP status codes
      switch (status) {
        case 500:
          message = "Internal Server Error";
          break;
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the data you are looking for could not be found";
          break;
        case 400:
          message = error.message || "Bad request";
          break;
        default:
          message = error.message || "An error occurred";
      }
    }

    console.error("Final error message to dispatch:", message);
    return Promise.reject(message);
  }
);
/**
 * Sets the default authorization
 * @param {*} token
 */
const setAuthorization = (token) => {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
};

class APIClient {
  /**
   * Fetches data from given url
   */

  //  get = (url, params) => {
  //   return axios.get(url, params);
  // };
  get = (url, params) => {
    let response;

    let paramKeys = [];

    if (params) {
      Object.keys(params).map(key => {
        paramKeys.push(key + '=' + params[key]);
        return paramKeys;
      });

      const queryString = paramKeys && paramKeys.length ? paramKeys.join('&') : "";
      response = axios.get(`${url}?${queryString}`, params);
    } else {
      response = axios.get(`${url}`, params);
    }

    return response;
  };
  /**
   * post given data to url
   */
  create = (url, data) => {
    return axios.post(url, data);
  };
  /**
   * Updates data
   */
  update = (url, data) => {
    return axios.patch(url, data);
  };

  put = (url, data) => {
    return axios.put(url, data);
  };
  /**
   * Delete
   */
  delete = (url, config) => {
    return axios.delete(url, { ...config });
  };
}
const getLoggedinUser = () => {
  const user = sessionStorage.getItem("authUser");
  if (user) {
    return JSON.parse(user);
  }
  // Check localStorage for remembered login
  const remembered = localStorage.getItem("rememberAuthUser");
  if (remembered) {
    const parsedUser = JSON.parse(remembered);
    // Restore to sessionStorage so normal session flow works
    sessionStorage.setItem("authUser", JSON.stringify(parsedUser));
    return parsedUser;
  }
  return null;
};

export { APIClient, setAuthorization, getLoggedinUser };